import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { userQuery } from '../../../core/authentication/queries';
import { useAppSelector } from '../../../types';
import { EmptyNetwork, TextInformation, Title } from './styles';

// Component used only if networkList is empty but will be implemented later
export const EmptyNetworkList: FC = () => {
    const { t } = useTranslation();
    const user = useAppSelector(userQuery);

    return (
        <EmptyNetwork>
            <TextInformation>
                {t('networkList.welcomeMessage')} {user?.lastName} {user?.firstName} !
            </TextInformation>
            <Title>{t('networkList.emptyNetwork')}</Title>
        </EmptyNetwork>
    );
};
